/**
 * Form builder persists `field_type` + `id`; public FormField expects `type` + `name`.
 */
export function normalizeFormField(raw) {
  const r = raw || {};
  const storageKey =
    (r.name != null && String(r.name).trim() !== '' && String(r.name)) ||
    r.id ||
    '';

  let type = r.field_type || r.type || 'text';
  if (type === 'phone') type = 'tel';
  if (type === 'attribute') type = 'text';

  return {
    ...r,
    name: storageKey || `field_${Math.random().toString(36).slice(2, 11)}`,
    type,
  };
}
